import './App.scss';
import './staticImages/staticImages';

import App from './App';
window.__APP = new App();
